import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const BscUsdtIcon: React.FC<SvgIconDefaultProps> = ({ className }) => {
  return (
    <CustomSvg
      className={className}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_3338_11571)">
        <path
          d="M40 20C40 23.9556 38.827 27.8224 36.6294 31.1114C34.4318 34.4004 31.3082 36.9638 27.6537 38.4776C23.9992 39.9913 19.9778 40.3874 16.0982 39.6157C12.2186 38.844 8.65492 36.9392 5.85787 34.1421C3.06082 31.3451 1.15601 27.7814 0.384303 23.9018C-0.387401 20.0222 0.0086656 16.0009 1.52242 12.3463C3.03617 8.69181 5.59962 5.56824 8.8886 3.37061C12.1776 1.17298 16.0444 0 20 0C25.3043 0 30.3914 2.10714 34.1421 5.85786C37.8929 9.60859 40 14.6957 40 20Z"
          fill="#161616"
        />
      </g>
      <path
        d="M15.7272 18.2444L19.9995 13.9723L24.2742 18.2467L26.7601 15.7608L19.9995 9L13.2412 15.7585L15.7272 18.2444Z"
        fill="#F3BA2F"
      />
      <path
        d="M13.9722 19.9996L11.4863 17.5137L9.00029 19.9997L11.4862 22.4856L13.9722 19.9996Z"
        fill="#F3BA2F"
      />
      <path
        d="M15.7279 21.755L20.0002 26.0272L24.2747 21.7529L26.762 24.2375L26.7608 24.2389L20.0002 30.9995L13.2418 24.2411L13.2383 24.2377L15.7279 21.755Z"
        fill="#F3BA2F"
      />
      <path
        d="M28.514 22.487L31 20.001L28.5141 17.5151L26.0281 20.0011L28.514 22.487Z"
        fill="#F3BA2F"
      />
      <path
        d="M22.521 19.9982H22.522L19.9994 17.4756L18.1352 19.3398H18.135L17.9209 19.5541L17.4791 19.9959L17.4756 19.9994L17.4791 20.0031L19.9994 22.5234L22.522 20.0008L22.5233 19.9994L22.521 19.9982Z"
        fill="#F3BA2F"
      />
      <defs>
        <clipPath id="clip0_3338_11571">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </CustomSvg>
  );
};

export default BscUsdtIcon;
